import React, { Component } from "react";
import AnimatedLoader from "./animated";

export default class Spinner extends Component {
	render() {
		return (
			<div
				className={
					"vmo-loader " + this.props.size + " " + this.props.background
				}
			>
				<div className="vmo-loader-inner-animated">
					<AnimatedLoader />
					{/*<div className="vmo-loader-circle">
						<svg xmlns="http://www.w3.org/2000/svg">
							<circle cx="0" cy="12" r="10" transform="translate(12 0)" />
						</svg>
					</div>*/}
				</div>
				{
						this.props.description && <p className="vmo-loader-text">{this.props.description}</p>
					}
			</div>
		);
	}
}
